<template>
    <div>
        <form :action="action" @submit.prevent="submit" ref="form" v-click-outside="reset">
            <div class="search-container">
                <div class="input">
                    <div class="input-group">
                        <input type="text" class="form-control search-control" name="term" v-model="searchTerm" @keyup.down="down" @keyup.up="up" @keyup="trigger" placeholder="Search for fasteners, fixings, tools and more..." autocomplete="off">
                        <span class="input-group-btn">
                            <button class="btn btn-blue"><i class="fa fa-search" aria-hidden="true"></i></button>
                        </span>
                    </div>
                </div>
                <div class="suggestions" v-if="autocomplete">
                    <template v-if="skus.length">
                        <a
                            href="#"
                            v-for="item in skus"
                            :key="item.sku"
                            :class="{'selected' : selectedElement && (item.sku == selectedElement.sku)}"
                            @click.prevent="submit(item, true)"
                        >
                            <strong>{{ item.sku }}</strong> &middot; <small>{{ item.name }}</small>
                        </a>
                    </template>
                    <template v-if="hasCategories">
                        <a
                            href="#"
                            v-for="item in categories"
                            :key="item.key"
                            :class="{'selected' : selectedElement && (item.id == selectedElement.id)}"
                            @click.prevent="submit(item)"
                        >
                            {{ searchTerm }} in <strong>{{ item.string }}</strong>
                        </a>
                    </template>
                    <span class="divider" v-if="fullresult">&nbsp;</span>
                    <template v-if="hasAutocomplete">
                        <a
                            href="#"
                            v-for="item in suggestions"
                            :key="item.key"
                            :class="{'selected' : selectedElement && (item.id == selectedElement.id)}"
                            @click.prevent="submit(item)"
                        >
                            {{ item.string }}
                        </a>
                    </template>
                </div>
                <!--    <a
                        href="#"
                        v-for="(item, index) in autocomplete" :key="item.key"
                        :class="{'selected' : (index == cursor)}"
                        @click.prevent="submit(item)"
                    >
                                {{ item.string }}
                        </a>
                </div> -->
                <!-- <div class="suggestions" v-if="finishedSuggest || alreadySuggested">
                    <span class="divider" v-if="categories.length">Browse categories relating to <strong>{{ searchTerm }}</strong></span>
                    <div class="category-suggests" v-if="categories.length">
                        <a
                            :href="getUrl('categories', category)"
                            v-for="category in categories" :key="category.id"
                            :class="{'selected' : selectedElement && (category.id == selectedElement.id)}"
                        >
                                {{ category.name }}
                        </a>
                    </div>
                    <span class="divider" v-if="products.length">Our most popular results matching <strong>{{ searchTerm }}</strong></span>
                    <div class="product-suggests" v-if="products.length">
                        <article>
                            <a
                                :href="getUrl('products', product)"
                                v-for="product in products"
                                :class="{'selected' : selectedElement && (product.id == selectedElement.id)}"
                            >
                                <figure>
                                    <img :src="product.thumbnail.url" v-if="product.thumbnail">
                                    <img src="/img/orbital/products/placeholder.png" v-else>
                                </figure>
                                <section>
                                    <strong>{{ product.name }}</strong>
                                </section>
                            </a>
                        </article>
                    </div>
                </div> -->
            </div>
        </form>
    </div>
</template>

<script>
    import Search from '../../Services/Search.js';
    import Utils from '../../Mixins/Utils';



    export default {
        mixins: [Utils],
        props: {
            term: {
                default: ''
            },
            action: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                searchTerm: '',
                selected: {},
                autocomplete: {},
                loading: false,
                cursor: null,
                cancelToken: null,
                skus: [],
            }
        },
        mounted() {
            this.searchTerm = this.term;
            this.refreshCancelToken();
        },
        methods: {
            refreshCancelToken() {
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                this.cancelToken = source;
            },
            cancel() {
                this.searchTerm = null;
                this.autocomplete = {};
                this.skus = [];
            },
            trigger: _.debounce(function (e) {
                const dontTrigger = ['ArrowDown', 'ArrowUp', 'Enter'];
                // If we're pressing the up or down arrow or enter, don't do this.
                if (dontTrigger.includes(e.key)) {
                    return;
                }

                this.cancelToken.cancel();

                this.refreshCancelToken();
                this.loading = true;
                this.cursor = null;

                if (!this.searchTerm) {
                    this.autocomplete = {};
                    return;
                }
                Search.getAutocomplete(this.searchTerm, this.cancelToken).then(response => {
                    this.autocomplete = {
                        autocomplete: _.take(response.data.autocomplete, 5),
                        categories: _.take(response.data.categories, 4),
                    };
                }).catch((error)=>{
                    if (! axios.isCancel(error)) {
                        // this.isLoading = false
                    }
                });
                Search.skuMatch(this.searchTerm, this.cancelToken).then(response => {
                    this.skus = response.data;
                }).catch((error)=>{
                    if (! axios.isCancel(error)) {
                        //
                    }
                });
            }, 200),
            url(product) {
                return '/products/' + product.routes[0].slug;
            },
            up() {
                if (this.cursor === null) {
                    return;
                }
                if (this.cursor === 0) {
                    this.cursor = null;
                    return;
                }
                this.cursor -= 1;
                if (!this.mapping[this.cursor]) {
                    this.down();
                }
            },
            down() {
                if (this.cursor === null) {
                    this.cursor = 0;
                } else {
                    this.cursor += 1;
                }
                if (!this.mapping[this.cursor]) {
                    this.up();
                }
            },
            getUrl(value) {
                return '/search?keywords=' + value;
            },
            reset() {
                this.autocomplete = null;
            },
            submit(item, sku) {
                // If we click one, prioritise that
                if (this.selectedElement && item.type == "submit") {
                    item = this.selectedElement;
                }
                if (item.string) {
                    let url = '/search';
                    if (item.level) {
                        url += '?term=' + this.searchTerm + '&CategoryPath_2=' + item.string;
                    } else {
                        url += '?term=' + item.string;
                    }
                    window.location = url;
                    return;
                } else if (item.sku) {
                    window.location = '/search?term=' + item.sku;
                    return;
                }
                this.$refs.form.submit();
            },
        },
        computed: {
            hasCategories() {
                return this.autocomplete &&
                    this.autocomplete.categories &&
                    this.autocomplete.categories.length;
            },
            hasAutocomplete() {
                return this.autocomplete &&
                    this.autocomplete.autocomplete &&
                    this.autocomplete.autocomplete.length;
            },
            categories() {
                return this.autocomplete.categories ? this.autocomplete.categories : [];
            },
            suggestions() {
                return this.autocomplete.autocomplete ? this.autocomplete.autocomplete : [];
            },
            mapping() {
                if (!this.autocomplete) {
                    return {};
                }
                let categories = _.map(_.take(this.categories, 4), item => {
                    let data = item;
                    data.level = 'CategoryLevel_2';
                    return data;
                });
                let products = _.map(_.take(this.suggestions, 5), item => {
                    let data = item;
                    return data;
                });
                let skus = _.map(this.skus, sku => {
                    return sku;
                });
                return skus.concat(categories).concat(products);
            },
            fullresult() {
                return this.hasCategories && this.hasAutocomplete;
            },
            selectedElement() {
                return this.mapping[this.cursor];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .autocomplete-product {
        display:block;
        padding:10px;
        figure {
            display:inline-block;
            width:20%;
        }
        > div {
            display:inline-block;
            padding:10px;
            width:80%;
        }
    }
    .search-container {
        position:relative;
        .close-btn {
            position: absolute;
            z-index: 50;
            right: 78px;
            top: 1px;
            height: 58px;
            width: 50px;
            padding-left: 0;
            padding-right: 0;
            color: #acacac;
            background: transparent;
            border: 0;
            border-left: 1px solid #d8d8d8
        }
        .divider {
            background-color:#ebebeb;
            color:darken(#ebebeb, 45%);
            font-size:.875em;
            display:block;
            padding:.5em 10px;
            font-style: italic;
        }
        .suggestions {
            position:absolute;
            // max-height:700px;
            // overflow: scroll;
            font-size:.875em;
            background-color:white;
            box-shadow: 0px 2px 10px 0px rgba(0,0,0,.24);
            z-index:2000;
            width:100%;
            figure {
                float:left;
                width:10%;
                img {
                    max-width:100%;
                }
            }
            section {
                display:inline-block;
                padding-top:.5em;
                float:left;
                width:85%;
                padding-left:5%;
            }
            a {
                border-bottom:1px solid #f5f5f5;
                display:block;
                padding:1em 10px;
                overflow:hidden;
                white-space: nowrap;
                small {
                    color: #777;
                }
                &:after {
                    content: '';
                    position: absolute;
                    right:0;
                    top:0;
                    bottom:0;
                    width:50px;
                    background: rgb(255,255,255);
                    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
                }
                &.selected {
                    background-color:#0c5997;
                    color:white;
                    small {
                        color:inherit;
                    }
                    &:after {
                        display:none;
                    }
                    &:hover {
                        background-color:#0c5997;
                        color:white;
                    }
                }
                &:hover {
                    background-color:#f5f5f5;
                    color:#09487b;
                }
            }
        }
    }
    @media screen and (min-width: 600px) {
        .close-btn {
            display:none!important;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/SearchInput.vue